<template>
  <div>
    <DxPopup
      :visible="visible"
      @hiding="onHiding"
      @shown="popupShown"
      :width="'80%'"
      :height="'50%'"
      :show-title="true"
      :title="popupTitle"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :show-close-button="true"
      :wrapperAttr="{ class: 'css-v2 gc-popup-invoice-balance-history' }"
    >
      <template #content>
        <div class="css-v2 transaction-screen">
          <DxDataGrid
            v-if="loaded"
            :data-source="getDataSource"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :allow-column-resizing="true"
            :word-wrap-enabled="true"
            :pager="{ visible: false }"
            :column-chooser="{ enabled: false }"
            :columns="getColumns"
            :height="gridHeight"
            :remote-operations="'auto'"
            :ref="gridRef"
            @content-ready="onContentReady"
          >
            <DxPaging :page-size="50" :enabled="true" />
            <DxScrolling
              :mode="'standard'"
              :row-rendering-mode="'standard'"
              :preloadEnabled="true"
            />
            <DxSearchPanel :visible="false" />

            <template #Hyperlink="{ data }">
              <div
                v-if="
                  data.data.TransactionType === 'Receipt' ||
                  data.data.TransactionType === 'Payment'
                "
              >
                <a @click="onHyperlinkClicked(data)">
                  <span>{{ data.text }}</span>
                </a>
              </div>
              <div v-else>
                <span>{{ data.text }}</span>
              </div>
            </template>

            <template #DecimalCell="{ data }">
              <GcDecimal :dataValue="data" :format="data.column.format" />
            </template>

            <DxSummary>
              <DxTotalItem
                column="FXAmount"
                summary-type="sum"
                :value-format="'##,###,###,###,##0.0000;( ##,###,###,###,##0.0000)'"
                name="FXAmount"
                display-format="{0}"
              />
              <DxTotalItem
                column="FXDiscount"
                summary-type="sum"
                :value-format="'##,###,###,###,##0.0000;(##,###,###,###,##0.0000)'"
                name="FXDiscount"
                display-format="{0}"
              />
            </DxSummary>
          </DxDataGrid>

          <GcFooter v-if="showFooter">
            <template #rightContent>
              <div
                class="gc-grid-footer-item"
                v-for="item in footerRightItems"
                :key="item.label"
              >
                <label class="gc-footer-label">{{ item.label }}</label>
                <GcFooterItem
                  :value="item.value"
                  :format="item.format"
                  :length="item.format == 'Decimal-16-4C' ? 8 : 6"
                />
              </div>
            </template>
          </GcFooter>
        </div>
      </template>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import { DxDataGrid, DxScrolling, DxPaging } from "devextreme-vue/data-grid";
import appConfig from "../../app-config";
import * as AspNetData from "devextreme-aspnet-data-nojquery";
import { TokenStorage } from "../../_services/storage";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import {
  getDefaultCustomerSettings,
  getGlobalField,
} from "../../_store/helpers";

export default {
  name: "InvoiceHistoryPopup",
  components: {
    DxPopup,
    DxDataGrid,
    DxScrolling,
    DxPaging,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    invoiceNumber: {
      type: [String, Number],
      default: "",
      required: true,
    },
    customerNumber: {
      type: [String, Number],
      default: "",
      required: true,
    },
    InvoicedAmount: {
      type: Number,
      default: 0,
    },
    InvoiceType: {
      type: String,
      default: "Customer",
    },
    CurrencyCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
      gridHeight: "auto",
      CustomerCurrency: undefined,
      showFooter: true,
      footerItems: [],
      gridRef: "dx-data-grid-comp",
      TotalAllocated: 0,
      TotalDiscount: 0,
      RemoteURL:
        appConfig.VUE_APP_ROOT_API + "/apiv2/CustomerInvoiceBalanceHistory",
      MainFilter: [
        ["SourceCustomerInvoiceCode", "=", this.invoiceNumber],
        "and",
        [
          ["TransactionType", "=", "Receipt"],
          "or",
          ["TransactionType", "=", "Credit"],
        ],
      ],
    };
  },
  methods: {
    onHiding() {
      this.$emit("update:visible", false);
    },
    async popupShown(e) {
      if (this.InvoiceType === "Supplier") {
        this.RemoteURL =
          appConfig.VUE_APP_ROOT_API + "/apiv2/SupplierInvoiceBalanceHistory";

        this.MainFilter = [
          ["SourceSupplierInvoiceCode", "=", this.invoiceNumber],
          "and",
          [["TransactionType", "=", "Payment"]],
        ];
      }

      if (this.InstanceType == "Customer") {
        await this.$store.dispatch(
          "defaultCustomerSettings/setCustomerById",
          this.customerNumber,
        );
      }

      this.$nextTick(() => {
        if (this.CurrencyCode) {
          this.CustomerCurrency = this.CurrencyCode;
        } else {
          this.CustomerCurrency = getDefaultCustomerSettings().CustomerCurrency;
        }

        this.setFooterItems([]);

        this.loaded = true;
        var content = e.component._$content;

        setTimeout(() => {
          var popupHeight =
            content[0].querySelectorAll(".dx-popup-content")[0].clientHeight;

          var dataGridElement = content[0].querySelectorAll(
            ".dx-datagrid-rowsview",
          )[0];

          if (dataGridElement) {
            this.gridHeight = `${popupHeight - 20 - 40}px`;
          }
        }, 100);
      });
    },

    onHyperlinkClicked(e) {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      let url = undefined;
      if (e.data.TransactionType == "Receipt") {
        url = `customer-receipt/review/${e.data.Reference}`;
      } else if (e.data.TransactionType == "Credit") {
        url = `credit-customer/review/${e.data.Reference}`;
      } else if (
        this.InvoiceType === "Supplier" &&
        e.data.TransactionType == "Payment"
      ) {
        url = `supplier-payment/review/${e.data.Reference}`;
      }

      if (url) {
        if (baseUrl != "/") url = "/" + url;
        else url = baseUrl + url;
        var route = this.$router.resolve({ path: url });
        window.open(route.href, "_blank");
      }
    },

    onContentReady(e) {
      if (e) {
        this.setFooterItems(e.component.getDataSource().items());
      }
    },

    // Footer
    getTotalSummaryValue() {
      var dataGrid = this.$refs[this.gridRef].instance;

      if (dataGrid) {
        this.TotalAllocated = dataGrid.getTotalSummaryValue("FXAmount");
        this.TotalDiscount = dataGrid.getTotalSummaryValue("FXDiscount");
      }
    },
    async setFooterItems(gridItems) {
      if (!this.$refs[this.gridRef]) return;
      var dataGrid = this.$refs[this.gridRef].instance;

      if (!dataGrid) return;
      this.getTotalSummaryValue();
      // this.showFooter = false;
      this.getFooterItems
        .filter((x) => (x.hasOwnProperty("visible") ? x.visible : true))
        .forEach((x) => {
          x.value = dataGrid
            ? dataGrid.getTotalSummaryValue(x.dataField) || 0
            : 0;
          if (x.customCalc) x.value = x.customCalc(this.model, gridItems);
        });
      this.footerItems = this.getFooterItems;
      this.showFooter = true;
    },
  },
  computed: {
    popupTitle() {
      return `Invoice # ${this.invoiceNumber} Balance History`;
    },
    getDataSource() {
      return this.gridRemoteDataSource;
    },
    gridRemoteDataSource() {
      return AspNetData.createStore({
        loadUrl: this.RemoteURL,
        // key: "RecordId",
        loadParams: {
          filter: JSON.stringify([this.MainFilter]),
        },
        onBeforeSend: function (method, request) {
          request.headers = {
            Authorization: `Bearer ${TokenStorage.getToken()}`,
            "Content-Type": "application/json",
            "x-tenant-id": TokenStorage.getTenant(),
          };
        },
      });
    },
    getColumns() {
      return [
        {
          caption: "Date",
          dataField: "TransactionDate",
          format: "dd MMM yyyy",
          dataType: "date",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          sortOrder: "desc",
          sortIndex: 0,
        },
        {
          caption: "Type",
          dataField: "TransactionType",
          minWidth: ColumnWidth.TransactionType.minWidth,
          width: ColumnWidth.TransactionType.width,
        },
        {
          caption: "Reference #",
          dataField: "Reference",
          cellTemplate: "Hyperlink",
          alignment: "left",
        },
        {
          caption: `Amount (${this.CustomerCurrency})`,
          dataField: "FXAmount",
          width: ColumnWidth.Price4DecimalPoints.width,
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          cellTemplate: "DecimalCell",
          calculateCellValue: (data) => {
            return data.FXAmount * -1;
          },
        },
        {
          caption: `Discount (${this.CustomerCurrency})`,
          dataField: "FXDiscount",
          width: ColumnWidth.Price4DecimalPoints.width,
          minWidth: ColumnWidth.Price4DecimalPoints.minWidth,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          cellTemplate: "DecimalCell",
          calculateCellValue: (data) => {
            return data.FXDiscount * -1;
          },
        },
      ];
    },

    // Footer
    getFooterItems() {
      return [
        {
          screenField: "FXAmount",
          location: "right",
          value: this.InvoicedAmount,
          dataField: "InvoicedAmount",
          format: "Decimal-16-2",
          label: `Invoice Amount (${this.CustomerCurrency})`,
          customCalc: () => {
            if (this.InvoicedAmount) return this.InvoicedAmount;
            else return 0;
          },
        },
        {
          screenField: "Allocated",
          location: "right",
          value: 0,
          dataField: "FXAmount",
          format: "Decimal-16-2",
          label: `Allocated (${this.CustomerCurrency})`,
        },
        {
          screenField: "Discount",
          location: "right",
          value: 0,
          dataField: "FXDiscount",
          format: "Decimal-16-2",
          label: `Discount (${this.CustomerCurrency})`,
        },
        {
          screenField: "Balance",
          location: "right",
          value: 0,
          dataField: "Balance",
          format: "Decimal-16-2",
          label: `Balance (${this.CustomerCurrency})`,
          customCalc: () => {
            if (this.InvoicedAmount) {
              return (
                this.InvoicedAmount - this.TotalAllocated - this.TotalDiscount
              );
            } else return 0;
          },
        },
      ];
    },
    footerRightItems() {
      // return this.footerItems.filter((x) => x.location == "right");
      var rightItems = this.footerItems.filter(
        (x) =>
          x.location == "right" &&
          (x.hasOwnProperty("visible") ? x.visible : true),
      );

      return rightItems
        .map((c) => {
          let globalField = { ...getGlobalField(c.screenField) };

          if (Object.keys(globalField).length == 0) return c;

          if (c.value != undefined) globalField.value = c.value;
          if (c.dataField != undefined) globalField.dataField = c.dataField;
          if (c.label != undefined) globalField.label = c.label;
          if (c.format != undefined) globalField.format = c.format;

          if (globalField) return globalField;
          else return c;
        })
        .filter((x) => x != null);
    },
  },
};
</script>

<style lang="scss">
.gc-popup-invoice-balance-history {
  .dx-datagrid-total-footer {
    display: none;
  }

  .dx-popup-content {
    padding: unset !important;
  }
}
</style>
